module.exports = __webpack_public_path__ + "img/coupon.a108813.png";